/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import AKBadge from '@atlaskit/badge';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var badgeStyles = css({
  alignItems: 'center',
  display: 'inline-flex'
});

/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */

var AtlaskitBadge = function AtlaskitBadge(_ref) {
  var value = _ref.value,
    name = _ref.name,
    overrideCss = _ref.overrideCss,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-atlaskit-badge' : _ref$testId;
  if (!value) {
    return null;
  }
  return jsx("span", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    css: [badgeStyles, overrideCss],
    "data-fit-to-content": true,
    "data-smart-element": name,
    "data-smart-element-atlaskit-badge": true,
    "data-testid": testId
  }, jsx(AKBadge, null, value));
};
export default AtlaskitBadge;